import {
  DoorFront,
  GroupAdd,
  Visibility,
  VisibilityOff
} from '@mui/icons-material'
import { Box, Button, Icon, TextField, Typography, Zoom } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import {
  camelizeFieldNames,
  mapOperationsToDispatchProps,
  post
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

interface OwnProps {
  openRegister: boolean
  setOpenRegister: (_: boolean) => void
}

type AppProps = StateProps & DispatchProps & OwnProps

const NivosRegisterFC: React.FC<any> = (props: AppProps) => {
  const { openRegister, setOpenRegister } = props

  const clearFormValues = {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    rePassword: ''
  }

  const defaultErrorValues = {
    email: '',
    firstName: '',
    lastName: '',
    password: ''
  }

  const [formValues, setFormValues] = React.useState(clearFormValues)
  const [formErrors, setFormErrors] = React.useState(defaultErrorValues)
  const [showHidePass, setShowHide] = React.useState({
    password: false,
    rePassword: false
  })

  const _submitRegistration = (): void => {
    if (formValues.password !== formValues.rePassword) {
      setFormErrors({
        ...formErrors,
        password: 'Passwords does not match!'
      })
      return
    }

    const registerData = {
      email: formValues.email,
      first_name: formValues.firstName,
      last_name: formValues.lastName,
      password: formValues.password
    }

    void post('/account/register/', registerData).then(data => {
      if (data.id !== undefined && data.id > 0) {
        _clearForm()
        setOpenRegister(false)
      } else {
        const errorFields = Object.entries(camelizeFieldNames(data))
        const errorStates: any = { ...formErrors }
        errorFields.forEach(field => {
          errorStates[field[0]] = field[1][0]
        })

        setFormErrors(errorStates)
      }
    })
  }

  const _clearForm = (): void => {
    setFormValues(clearFormValues)
    setFormErrors(defaultErrorValues)
  }

  return (
    <Zoom in={openRegister} unmountOnExit>
      <Box
        width={0.75}
        height={800}
        paddingTop={4}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <Zoom in={true} timeout={1250}>
          <Typography align={'center'} variant={'h2'}>
            Join us!
          </Typography>
        </Zoom>
        <Zoom in={true} timeout={2500}>
          <Typography align={'center'} paddingBottom={4}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi
            vehicula, porttitor nisi in.
          </Typography>
        </Zoom>
        <Zoom in={true} timeout={3000}>
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-evenly'}
          >
            <Box marginBottom={3}>
              {formErrors.firstName !== '' && (
                <Typography variant={'body2'} color={'red'}>
                  {formErrors.firstName}
                </Typography>
              )}
              <TextField
                fullWidth
                autoComplete={'off'}
                label={'First name'}
                sx={{ marginBottom: 3 }}
                value={formValues.firstName}
                error={formErrors.firstName !== ''}
                onChange={event => {
                  setFormValues({
                    ...formValues,
                    firstName: event.currentTarget.value
                  })
                  setFormErrors({ ...formErrors, firstName: '' })
                }}
              />
              {formErrors.lastName !== '' && (
                <Typography variant={'body2'} color={'red'}>
                  {formErrors.lastName}
                </Typography>
              )}
              <TextField
                fullWidth
                autoComplete={'off'}
                label={'Last name'}
                sx={{ marginBottom: 3 }}
                value={formValues.lastName}
                error={formErrors.lastName !== ''}
                onChange={event => {
                  setFormValues({
                    ...formValues,
                    lastName: event.currentTarget.value
                  })
                  setFormErrors({ ...formErrors, lastName: '' })
                }}
              />
              {formErrors.email !== '' && (
                <Typography variant={'body2'} color={'red'}>
                  {formErrors.email}
                </Typography>
              )}
              <TextField
                fullWidth
                autoComplete={'off'}
                label={'E-mail'}
                type={'email'}
                sx={{ marginBottom: 3 }}
                value={formValues.email}
                error={formErrors.email !== ''}
                onChange={event => {
                  setFormValues({
                    ...formValues,
                    email: event.currentTarget.value
                  })
                  setFormErrors({ ...formErrors, email: '' })
                }}
              />
              {formErrors.password !== '' && (
                <Typography variant={'body2'} color={'red'}>
                  {formErrors.password}
                </Typography>
              )}
              <TextField
                fullWidth
                autoComplete={'off'}
                label={'Password'}
                type={showHidePass.password ? 'text' : 'password'}
                sx={{ marginBottom: 3 }}
                value={formValues.password}
                error={formErrors.password !== ''}
                InputProps={{
                  startAdornment: (
                    <Icon
                      style={{
                        marginRight: 5,
                        cursor: 'pointer'
                      }}
                      onClick={() =>
                        setShowHide({
                          ...showHidePass,
                          password: !showHidePass.password
                        })
                      }
                    >
                      {showHidePass.password ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </Icon>
                  )
                }}
                onChange={event => {
                  setFormValues({
                    ...formValues,
                    password: event.currentTarget.value
                  })
                  setFormErrors({ ...formErrors, password: '' })
                }}
              />
              <TextField
                fullWidth
                autoComplete={'off'}
                label={'Repeat Password'}
                type={showHidePass.rePassword ? 'text' : 'password'}
                value={formValues.rePassword}
                error={formErrors.password !== ''}
                onChange={event => {
                  setFormValues({
                    ...formValues,
                    rePassword: event.currentTarget.value
                  })
                  setFormErrors({ ...formErrors, password: '' })
                }}
                InputProps={{
                  startAdornment: (
                    <Icon
                      style={{
                        marginRight: 5,
                        cursor: 'pointer'
                      }}
                      onClick={() =>
                        setShowHide({
                          ...showHidePass,
                          rePassword: !showHidePass.rePassword
                        })
                      }
                    >
                      {showHidePass.rePassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </Icon>
                  )
                }}
              />
            </Box>
            <Button
              variant={'contained'}
              size={'large'}
              endIcon={<GroupAdd fontSize={'large'} />}
              onClick={() => _submitRegistration()}
              style={{
                marginBottom: 15
              }}
            >
              Register
            </Button>
            <Button
              variant={'outlined'}
              size={'large'}
              endIcon={<DoorFront fontSize={'large'} />}
              onClick={() => setOpenRegister(false)}
            >
              Login
            </Button>
          </Box>
        </Zoom>
      </Box>
    </Zoom>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const NivosRegister = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosRegisterFC as React.FC<OwnProps>)

export default NivosRegister
